export default __webpack_public_path__ + "static/smh-c98c89b26ff9455637136c15d2779bc0.png";